import React, { useRef, useState } from 'react'
import cookies from 'react-cookies'
import { Link, navigate } from 'gatsby'
import { Menu, Dropdown, Avatar } from 'antd'
import { logout, setProfileData } from '../../../redux/actions/user'
import Navigation from '../navigation'
import DashboardNavigation from '../navigation/dashboard-navigation'
import { auth0Roles } from '../../../config'
import { IsUserLoggedIn } from '../../../functions'
import { useDispatch, useSelector } from 'react-redux'
import ADScript from '../../adScript'
import EmployerDashBoardSidebar from '../../employerDashboard/sidebar'
import SwitchOrganizationModal from '../../Modals/switchOrganization'

const Header = ({
  isEmployerDashboard,
  employerFacing,
  openLoginModal,
  // openSignupModal,
  location,
  user,
  userRole,
}) => {
  const dispatch = useDispatch()
  const profileData = useSelector(state => state.user.profileData)
  const namedUserEmployerProfiles = useSelector(
    state => state.user.namedUserEmployerProfiles
  )

  const showDropdownOnMobile = useRef(null)
  const [showOrHideBlurDiv, setShowOrHideBlurDiv] = useState(false)
  const [switchOrganizationModalVisible, setSwitchOrganizationModalVisible] =
    useState(false)

  const MenuList = () => {
    return (
      <Menu>
        <Menu.Item>
          <Link
            className="font-sans text-sm"
            to={
              userRole === auth0Roles.Member.id
                ? '/profile'
                : '/employer-dashboard/company-profile/'
            }
          >
            Profile
          </Link>
        </Menu.Item>

        <Menu.Item>
          <Link
            className="font-sans text-sm"
            to={
              userRole === auth0Roles.Member.id
                ? '/account-candidate'
                : '/employer-dashboard/account/'
            }
          >
            Account
          </Link>
        </Menu.Item>

        <Menu.Item
          className="font-sans text-sm"
          onClick={() => {
            dispatch(logout())
          }}
        >
          <span className="text-merlot font-sans text-sm">Logout</span>
        </Menu.Item>
      </Menu>
    )
  }

  const AvatarComponent = () => {
    return (
      <div className="flex items-center">
        {profileData?.image ? (
          <img
            className="w-[3rem] h-[3rem] lg:w-14 lg:h-14 rounded-full"
            src={profileData?.image?.url}
          />
        ) : (
          <Avatar shape="square" className="shadow" size={46} />
        )}
        <span className="ml-1 sm:ml-4 text-sm font-sans mb-0 break-words w-[70px] lg:w-max">
          {profileData?.name || ''}
        </span>
        <img src="/icons/down-arrow.svg" className="mb-0 ml-1 sm:ml-4" />
      </div>
    )
  }

  // function openSignupModalFromChild() {
  //   openSignupModal()
  // }

  function toggleBlur() {
    setShowOrHideBlurDiv(!showOrHideBlurDiv)
  }

  const openSwitchOrganizationModal = () => {
    setSwitchOrganizationModalVisible(true)
  }

  const closeSwitchOrganizationModal = () => {
    setSwitchOrganizationModalVisible(false)
  }

  const switchOrganization = organizationId => {
    const organizationProfile = namedUserEmployerProfiles.find(
      profile => profile.id.toString() === organizationId
    )
    dispatch(setProfileData(organizationProfile))
    cookies.save('selectedNamedUserEmployerId', organizationId, {
      path: '/',
      maxAge: 518400,
    })
    closeSwitchOrganizationModal()
  }

  const navigateJoinNow = () => {
    navigate('/join-now')
  }

  return (
    <>
      {showOrHideBlurDiv && <div className="blur-wrapper"></div>}
      <div className="sticky top-0 header-container pt-5 px-4 lg:px-0 bg-white z-50">
        <div
          className={` ${
            isEmployerDashboard ? 'w-full lg:w-11/12' : 'container'
          } mx-auto flex px-8 justify-between items-center pb-5 pt-1`}
        >
          <div className="flex">
            <img
              src="/icons/hamburger.svg"
              alt="Medreps Logo"
              className="lg:hidden pl-0 lg:pl-5 pr-5 cursor-pointer"
              onClick={() => showDropdownOnMobile.current()}
            />
            <Link to="/">
              <img
                src="/images/logo.png"
                className="w-[8rem] lg:w-40 mb-0"
                alt="Medreps Logo"
              />
            </Link>
          </div>
          <div className="flex items-center justify-center">
            <ADScript />
          </div>
          <>
            {IsUserLoggedIn() ? (
              <div className="flex items-center">
                {userRole === auth0Roles.NamedUser.id &&
                  namedUserEmployerProfiles?.length >= 2 && (
                    <button
                      className="mr-4"
                      onClick={openSwitchOrganizationModal}
                    >
                      Switch Organizations
                    </button>
                  )}
                <Dropdown
                  overlay={MenuList}
                  placement="bottomLeft"
                  arrow
                  trigger={['click']}
                >
                  <button>
                    <AvatarComponent />
                  </button>
                </Dropdown>
              </div>
            ) : (
              <div className="flex items-center">
                <span
                  onClick={() => openLoginModal()}
                  className="text-black text-base font-sans font-normal mr-12 cursor-pointer"
                >
                  Login
                </span>
                <span className="hidden lg:block">
                  {employerFacing ? (
                    <Link to="/employer/signup">
                      <button className="text-white py-4 px-10 bg-voyage cursor-pointer font-sans font-bold rounded">
                        Register
                      </button>
                    </Link>
                  ) : (
                    <button
                      onClick={() => navigateJoinNow()}
                      className="text-white py-4 px-10 bg-button cursor-pointer font-sans rounded"
                    >
                      Join Now
                    </button>
                  )}
                </span>
              </div>
            )}
          </>
        </div>

        {!isEmployerDashboard ? (
          <Navigation
            location={location}
            showDropdownOnMobile={showDropdownOnMobile}
            // openSignupModalFromChild={openSignupModalFromChild}
            toggleBlur={toggleBlur}
            isEmployerDashboard={isEmployerDashboard}
            employerFacing={employerFacing}
            userRole={userRole}
          />
        ) : (
          <DashboardNavigation
            location={location}
            showDropdownOnMobile={showDropdownOnMobile}
            toggleBlur={toggleBlur}
            user={user}
          />
        )}
      </div>
      <SwitchOrganizationModal
        modalOpen={switchOrganizationModalVisible}
        close={closeSwitchOrganizationModal}
        switchOrganization={switchOrganization}
      />
    </>
  )
}
export default Header
